// extracted by mini-css-extract-plugin
module.exports = {"background":"CreateUserModal_background__vTtNy","modal":"CreateUserModal_modal__23WgD"};